(() => {
  if (window.artistOrderPaginationReady) return;
  window.artistOrderPaginationReady = true;

  const parameter = 'artist_page';

  function pageUrl(page) {
    const url = new URL(window.location.href);
    if (page === 1) url.searchParams.delete(parameter);
    else url.searchParams.set(parameter, String(page));
    return url.pathname + url.search + url.hash;
  }

  function currentPage(total) {
    const requested = Number.parseInt(new URL(window.location.href).searchParams.get(parameter), 10);
    return Number.isFinite(requested) ? Math.min(Math.max(requested, 1), total) : 1;
  }

  function makeLink(page, label, update) {
    const link = document.createElement('a');
    link.className = 'pagination__link';
    link.href = pageUrl(page);
    link.textContent = label;
    link.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      window.history.pushState(null, '', link.href);
      update();
    });
    return link;
  }

  function initialize(root) {
    if (root.dataset.artistPaginationInitialized === 'true') return;
    root.dataset.artistPaginationInitialized = 'true';

    const items = Array.from(root.querySelectorAll('[data-artist-page-item]'));
    const nav = root.querySelector('[data-artist-page-nav]');
    const pageSize = Number.parseInt(root.dataset.artistPageSize, 10);
    if (!nav || !pageSize || !items.length) return;

    const totalPages = Math.ceil(items.length / pageSize);
    const grid = root.classList.contains('works-grid--natural') ? root.querySelector('.works-grid__grid') : null;
    let masonryFrame = 0;

    const layoutMasonry = () => {
      if (!grid) return;
      const columns = window.innerWidth < 650 ? 1 : window.innerWidth < 990 ? 2 : 3;
      const gap = 28;
      const width = (grid.clientWidth - gap * (columns - 1)) / columns;
      const heights = Array(columns).fill(0);

      items.forEach((item) => {
        if (item.hidden) return;
        const shortest = heights.indexOf(Math.min(...heights));
        item.style.width = `${width}px`;
        item.style.left = `${shortest * (width + gap)}px`;
        item.style.top = `${heights[shortest]}px`;
        heights[shortest] += item.offsetHeight + gap;
      });

      grid.style.height = `${Math.max(...heights) - gap}px`;
      root.classList.add('artist-masonry-ready');
    };

    const scheduleMasonry = () => {
      if (!grid) return;
      window.cancelAnimationFrame(masonryFrame);
      masonryFrame = window.requestAnimationFrame(layoutMasonry);
    };

    if (grid) {
      window.addEventListener('resize', scheduleMasonry);
      if (window.ResizeObserver) {
        const observer = new ResizeObserver(scheduleMasonry);
        items.forEach((item) => observer.observe(item));
      }
    }

    const update = () => {
      const page = currentPage(totalPages);
      items.forEach((item, index) => {
        item.hidden = index < (page - 1) * pageSize || index >= page * pageSize;
      });
      scheduleMasonry();

      nav.replaceChildren();
      nav.hidden = totalPages < 2;
      if (totalPages < 2) return;

      if (page > 1) nav.append(makeLink(page - 1, nav.dataset.artistPrevLabel || 'Previous', update));
      const state = document.createElement('span');
      state.className = 'pagination__state';
      state.textContent = `${page} / ${totalPages}`;
      nav.append(state);
      if (page < totalPages) nav.append(makeLink(page + 1, nav.dataset.artistNextLabel || 'Next', update));
    };

    window.addEventListener('popstate', update);
    update();
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll('[data-artist-pagination]').forEach(initialize);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
